import { useLang } from '@/i18n';
import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('delta3series');

    return (
        <div className={`${styles.TheComp} GtmModuleData-section range8`} data-section-id="D3-M" id='D3-M'>
            <EfSpec className="spec-m" />
            <EfSection
                title={t('M_title')}
                desc={t('M_desc')}
                pc="https://websiteoss.ecoflow.com/upload/image/1775285480218/pc11.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1775285480037/m11.jpg"
            />
        </div>
    );
}
